import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import CandidateProfileForm from "@/components/forms/CandidateProfileForm";
import ApplicationsTab from "./candidate/ApplicationsTab";
import FavoritesTab from "./candidate/FavoritesTab";
import PendingRatingsTab from "@/components/ratings/PendingRatingsTab";
import MessagesTab from "@/components/messages/MessagesTab";

const TABS = ["profile", "applications", "favorites", "ratings", "messages"];

export default function CandidateDashboardPage() {
  const { t } = useTranslation();
  const { tab = "profile" } = useParams();
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-8 py-10 sm:py-14" data-testid="candidate-dashboard-page">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold mb-8">{t("dashboard.candidateDashboard")}</h1>
      <Tabs value={TABS.includes(tab) ? tab : "profile"} onValueChange={(v) => navigate(`/dashboard/candidate/${v}`)}>
        <TabsList className="mb-8 rounded-xl">
          <TabsTrigger value="profile" data-testid="candidate-tab-profile">{t("dashboard.tabProfile")}</TabsTrigger>
          <TabsTrigger value="applications" data-testid="candidate-tab-applications">{t("dashboard.tabApplications")}</TabsTrigger>
          <TabsTrigger value="messages" data-testid="candidate-tab-messages">{t("dashboard.tabMessages")}</TabsTrigger>
          <TabsTrigger value="favorites" data-testid="candidate-tab-favorites">{t("dashboard.tabFavorites")}</TabsTrigger>
          <TabsTrigger value="ratings" data-testid="candidate-tab-ratings">{t("dashboard.tabRatings")}</TabsTrigger>
        </TabsList>
        <TabsContent value="profile">
          <div className="bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 sm:p-8">
            <CandidateProfileForm />
          </div>
        </TabsContent>
        <TabsContent value="applications"><ApplicationsTab /></TabsContent>
        <TabsContent value="messages"><MessagesTab /></TabsContent>
        <TabsContent value="favorites"><FavoritesTab /></TabsContent>
        <TabsContent value="ratings"><PendingRatingsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
